import { useQuery } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { EstimateChatSummary } from "@rebuild/shared/models";
import { INTERNAL_VIEW_POLL_MS, useIsInternalChatView } from "./internalView";
import { ESTIMATE_CHAT_KEYS } from "./queryKeys";

const { estimateChatControllerListChats } = getRebuildAPI();

// organizationId is the estimate's org, from its detail. Chats are read from that org, so the query
// waits for it. It isn't part of the key: an estimate belongs to exactly one org.
export function useEstimateChatsQuery(estimateId: string, organizationId: string | undefined) {
  const isInternalView = useIsInternalChatView(organizationId);
  return useQuery({
    queryKey: ESTIMATE_CHAT_KEYS.chats(estimateId),
    queryFn: async (): Promise<EstimateChatSummary[]> => {
      const { chats } = await estimateChatControllerListChats(estimateId, { overrideOrganizationId: organizationId! });
      return chats;
    },
    enabled: !!organizationId,
    refetchInterval: isInternalView ? INTERNAL_VIEW_POLL_MS : false,
  });
}
